import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { FiGrid, FiCreditCard, FiList, FiLogOut, FiUsers, FiZap,FiShield } from 'react-icons/fi';

export default function Layout({ children }) {
  const { admin, logout } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();

  const navItems = [
    { path: '/dashboard',      icon: <FiGrid />,       label: 'Dashboard' },
    { path: '/create-payment', icon: <FiCreditCard />, label: 'Create Payment' },
    { path: '/transactions',   icon: <FiList />,       label: 'Transactions' },
    { path: '/power-dashboard',   icon:<FiZap />,       label: 'Power Dashboard' },
    { path: '/security-deposit-dashboard', icon: <FiShield />, label: 'Security Deposits' },
    { path: '/noc-dashboard', icon: <FiShield />, label: 'NOC Dashboard' },
    
    // Only shown to main_admin:
    ...(admin?.role === 'main_admin'
      ? [{ path: '/admins', icon: <FiUsers />, label: 'Admin Users' }]
      : []),
  ];

  const handleLogout = () => {
    logout();
    toast.success('Logged out');
    navigate('/login');
  };

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="brand">
            <img src="/logo.svg" alt="SteponePay" style={{ width: 28, height: 28 }} />
            <div>
              <div>SteponePay</div>
              <div className="brand-sub">Pay Gateway</div>
            </div>
          </div>
        </div>

        <nav className="sidebar-nav">
          {navItems.map(item => (
            <button
              key={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 8, padding: '0 4px' }}>
            Signed in as <strong style={{ color: 'var(--text2)' }}>{admin?.username}</strong>
            {admin?.role === 'main_admin' && (
              <span style={{ marginLeft: 6, fontSize: 10, color: 'var(--primary)' }}>👑</span>
            )}
          </div>
          <button className="btn btn-danger btn-sm btn-full" onClick={handleLogout}>
            <FiLogOut style={{ marginRight: 6 }} /> Logout
          </button>
        </div>
      </aside>

      <main className="main-content">{children}</main>
    </div>
  );
}